import './Icon_Collapse_All.css';

function Icon_Collapse_All() {
  return (
    
      <div className='collapse-all-icon-container'>
          <svg viewBox="0 0 24 24" className="collapse-all-icon-svg">
            <path d="m7 20 5-5 5 5"/><path d="m7 4 5 5 5-5"/>
             </svg>
      </div>
            
  );
}

export default Icon_Collapse_All;
